import { sortLessons } from '@/filters/lessons';
import i18n from '@/lib/i18n';

export default {
  availableCourses(state) {
    return state.courses.filter((i) => i.status !== 'playing');
  },
  activeCourses(state) {
    return state.courses.filter((i) => i.status === 'playing');
  },
  joinedCourses(state, getters) {
    return getters.activeCourses.filter((i) => !isCourseCompleted(i));
  },
  unfinishedCourses(state, getters) {
    return getters.activeCourses.filter((i) => !isCourseCompleted(i));
  },
  coursesWithBilling(state, getters) {
    return getters.joinedCourses.filter((i) => i.billing);
  },
  hasCourses(state) {
    return state.courses?.length;
  },
  getCoursesByCategory(state) {
    return (categoryId) => {
      let categoryFilter = ({ portal_section }) => {
        return portal_section === categoryId;
      };

      if (categoryId === 'joined') {
        categoryFilter = (course) => {
          return !course.portal_section && isCourseActive(course);
        };
      }

      if (categoryId === 'available') {
        categoryFilter = (course) => {
          return !course.portal_section && !isCourseActive(course);
        };
      }

      return state.courses.filter(categoryFilter);
    };
  },
  courseCategories(state, getters, rootState, rootGetters) {
    // return getCourseCategories(getters.orgMeta);
    const defaultCategories = [
      {
        title: i18n.t('portal.course.joinedCourses'),
        slug: 'joined',
        id: 'joined',
      },
      {
        title: i18n.t('portal.course.availableCourses'),
        slug: 'available',
        id: 'available',
      },
    ];

    const { portal_sections = [] } = rootGetters.orgMeta || {};

    // Ensure all sections have an id field for backward compatibility
    const sectionsWithId = portal_sections.map((section) => ({
      ...section,
      // Use id if available (new backend), otherwise use slug (old backend)
      id: section.id || section.slug,
    }));

    return [...defaultCategories, ...sectionsWithId];
  },
  courseCategory(state, getters) {
    return (categorySlug) => {
      return getters.courseCategories.find(({ slug }) => slug === categorySlug);
    };
  },
  singleCourse(state) {
    return (courseId) => {
      return state.courses.find((i) => i.id === courseId) || null;
    };
  },
  portalCourseChildLessons(state, getters) {
    return ({ campaign_id, id }, unfinished = false) => {
      let course = getters.singleCourse(campaign_id);
      if (!course) return [];
      return sortLessons(course.triggers).filter(
        ({ parent_trigger, finished }) => {
          return parent_trigger === id && (unfinished ? !finished : true);
        }
      );
    };
  },
};

const getCourseCategories = (orgMeta) => {
  const defaultCategories = [
    {
      title: i18n.t('portal.course.joinedCourses'),
      slug: 'joined',
    },
    {
      title: i18n.t('portal.course.availableCourses'),
      slug: 'available',
    },
  ];

  const { portal_sections = [] } = orgMeta || {};

  return [...defaultCategories, ...portal_sections];
};

const isCourseActive = ({ status }) => status === 'playing';

const isCourseCompleted = (course) => {
  const { schemaLevel, triggers } = course;
  const isSchemaLevelFull = schemaLevel === 'full';
  const allLessonsFinished = triggers.every((i) => i.finished);

  return isSchemaLevelFull && allLessonsFinished;
};
